import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LifeModeAddComponent } from './life-mode-add.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, FormsModule, ReactiveFormsModule],
  declarations: [LifeModeAddComponent],
  exports: [LifeModeAddComponent]
})
export class LifeModeAddModule { }
